import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { useEffect } from "react";
import Typography from '@mui/material/Typography';
import PersonIcon from '@mui/icons-material/Person';
import { useForm, FormContainer, FormErrorProvider } from "react-hook-form-mui";
import PasswordField from "../fields/PasswordField";
import { useI18N } from "../../context/I18NContext";
import { InputAdornment, useTheme } from "@mui/material";
import { CustomTextFieldElement } from "../../layouts/Theme";
export default function Credential(props) {
    const { t } = useI18N();
    const theme = useTheme();
    const formContext = useForm({});
    const onSubmit = (data, event) => {
    };
    const onError = (errors) => {
    };
    useEffect(() => {
        formContext.setValue('username', "iesolatie");
        formContext.setValue('password', "");
    }, []);
    return (_jsx(_Fragment, { children: _jsx(FormContainer, { formContext: formContext, onSuccess: onSubmit, onError: onError, children: _jsxs(FormErrorProvider, { onError: (error) => {
                    if (error.type === 'validate') {
                        console.log(error);
                    }
                    return t(error.type, 'error');
                }, children: [_jsx(Typography, { variant: "h6", sx: { color: theme.palette.text.primary, marginLeft: 1, marginTop: 2, marginBottom: 1 }, children: t(props.label) }), _jsx(CustomTextFieldElement, { required: true, label: t('Gebruikersnaam'), name: 'username', type: "input", InputProps: {
                            startAdornment: (_jsx(InputAdornment, { position: "start", children: _jsx(PersonIcon, {}) }))
                        }, sx: { my: 1 }, fullWidth: true }), _jsx(PasswordField, { label: "Nieuw wachtwoord", name: "new-password" }), _jsx(PasswordField, { label: "Oude wachtwoord ter controle", name: "password", required: true })] }) }) }));
}
